import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { MerchantMonthlySpendPage } from './MerchantMonthlySpendPage';

const searchSchema = z.object({
  month: z.string().optional(),
  receipt: z.string().optional(),
});

export const Route = createFileRoute('/_protected/_consumer/insights/merchant/$merchantName/')({
  component: MerchantMonthlySpendPage,
  validateSearch: searchSchema,
});
